import { render, staticRenderFns } from "./ShippingLocalList.vue?vue&type=template&id=70790ebe&scoped=true"
import script from "./ShippingLocalList.vue?vue&type=script&lang=js"
export * from "./ShippingLocalList.vue?vue&type=script&lang=js"
import style0 from "./ShippingLocalList.vue?vue&type=style&index=0&id=70790ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70790ebe",
  null
  
)

export default component.exports